import { Box, Tooltip } from "@mui/material";
import React from "react";
import {
  LayersControl,
  MapContainer,
  ScaleControl,
  TileLayer,
  GeoJSON,
  Marker,
  useMapEvents,
  useMapEvent,
} from "react-leaflet";

export function MapsCustom(params) {
  // console.log("Map Custom 2 : ", params.data);
  // console.log("Json Custom 2 : ", params.dataJson);

  const [marker, setMarker] = React.useState([]);

  
  return (
    <Box
      width={"100%"}
      height={"100%"}
      textAlign={"left"}
      bgcolor={"#ffffff"}
      padding={2}
      border={"1px solid #D3D3D3"}
      borderRadius={4}
    >
      <MapContainer
        center={params.dataJson[0].center}
        zoom={params.dataJson[0].zoom}
        minZoom={7}
        maxZoom={15}
        doubleClickZoom
          ={false}
      
      >
        

        <ScaleControl metric={true} imperial={false} position="bottomright" />

        <LayersControl
          position="topright"
          // collapsed={false}
        >
          <LayersControl.BaseLayer
            name="Open Street Maps"
            key={"layer-0"}
            children={
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                key={"open_street_maps"}
              />
            }
          />
          <LayersControl.BaseLayer
            name="Google Maps (Satelitte)"
            checked="true"
            key={1}
            children={
              <TileLayer
                attribution='&copy; <a target="_blank" href="https://www.google.com/intl/en-GB_ALL/permissions/geoguidelines/">GoogleMaps</a>'
                url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
                key={"google_earth"}
              />
            }
          />
        </LayersControl>
        <GeoJSON data={params.dataJson[0].data} style={{ weight: 1 ,color:params.dataJson[0].color, fillOpacity:0.5}}>
          <Tooltip direction="center">{params.dataJson[0].title}</Tooltip>
        </GeoJSON>
        <Marker position={[params.data.latitude, params.data.longitude]} />
      </MapContainer>
    </Box>
  );
}
